var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTowTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 66 66",
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_448_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_568_",
    d: "m61.9 31-9.6-9.6c-.2-.2-.4-.3-.7-.3h-9.5c-.5 0-1 .5-1 1v21h-36.3c-.5 0-1 .5-1 1v8.9c0 .6.5 1 1 1h5.5c0-.3-.1-.7-.1-1 0-4.3 3.5-7.8 7.8-7.8s7.8 3.5 7.8 7.8c0 .3 0 .7-.1 1h14.8c0-.3-.1-.7-.1-1 0-4.3 3.5-7.8 7.8-7.8s7.8 3.5 7.8 7.8c0 .3 0 .7-.1 1h5.5c.6 0 1-.4 1-1v-21.2c-.2-.3-.3-.6-.5-.8zm-4.4 6.3h-11.6v-11.4h3.1l8.6 8.6v2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_572_",
    d: "m48.1 47.2c-3.2 0-5.8 2.6-5.8 5.8s2.6 5.8 5.8 5.8 5.8-2.6 5.8-5.8c-.1-3.2-2.6-5.8-5.8-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_575_",
    d: "m17.9 47.2c-3.2 0-5.8 2.6-5.8 5.8s2.6 5.8 5.8 5.8 5.8-2.6 5.8-5.8-2.6-5.8-5.8-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_579_",
    d: "m8.9 32.6c1.9 0 3.5-1.6 3.5-3.5 0-1.6-1.1-2.9-2.5-3.4v-10.4l12.3 22.9h-1.4c-2 0-3.6 1.2-4.4 2.8h22.8v-1.5c-.9-.8-2-1.3-3.3-1.3h-1.6l-21-29.6c-.6-.8-1.5-1.3-2.5-1.3-1.1 0-2.1.6-2.7 1.5-.5.8-.6 1.9-.2 2.8v15c0 .6.4 1 1 1 .8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5c0-.6-.4-1-1-1s-1 .4-1 1c0 1.9 1.6 3.5 3.5 3.5zm1.9-23.5c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1-1.1-.5-1.1-1.1.4-1.1 1.1-1.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowTruck);
export default __webpack_public_path__ + "static/media/tow-truck.180f0116.svg";
export { ForwardRef as ReactComponent };